
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  mounted: function () {
    const $ = this.$,
          app = this.$app,
          self = this;
    const id = this.$route.params.id;
    const provider = new myApp.OpenStreetMapProvider();
    const map = new L.Map('detail-map', {
      zoomControl: false,
      dragging: false
    });
    myApp.detailMap = map;
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a class="external" target="_system" ' + 'href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    if (myApp.realPosition) L.marker(myApp.realPosition, {
      icon: myApp.GeoIcon
    }).addTo(map);
    this.getItem();
  },
  destroyed: function () {
    console.log('Detail confirm destroyed');
  },
  data: function () {
    return {
      lng: lng,
      item: {
        info: {},
        latlng: [],
        type: 'no-image',
        images: [],
        offers: [],
        stars: [],
        reviews: []
      },
      promoId: null,
      colors: [],
      promo: {
        images: [],
        video: []
      },
      review: {},
      weekdays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
      priceRange: {
        '1': 'low',
        '2': 'mediumLow',
        '3': 'medium',
        '4': 'mediumHigh',
        '5': 'high'
      },
      menu: {
        categories: []
      }
    };
  },
  methods: {
    showImages(index, source) {
      let images;

      switch (source) {
        case 'promo':
          images = this.promo.images;
          break;

        case 'item':
          images = this.item.images;
          break;
      }

      this.$app.photoBrowser.create({
        photos: images,
        popupCloseLinkText: lng.close,
        swiper: {
          initialSlide: index
        }
      }).open();
    },

    async translate(lng) {
      const q = [this.item.caption || '', this.item.description_short || '', this.item.description || '', this.item.info.services || '', this.item.info.specialities || '', this.item.info.payment_methods_text || ''];

      const originalLang = () => {
        this.$('.translate-caption').text(this.item.caption);
        this.$('.translate-description-short').text(this.item.description_short);
        this.$('.translate-description').text(this.item.description);
        this.$('.translate-services').text(this.item.info.services);
        this.$('.translate-specialities').text(this.item.info.specialities);
        this.$('.translate-payment_methods_text').text(this.item.info.payment_methods_text);
      };

      if (lng !== '-') {
        const APIKey = 'AIzaSyB8AY9p2GiPEq4iQ7gNmh5IRqI7MfKyy28';
        const url = 'https://translation.googleapis.com/language/translate/v2?key=' + APIKey;
        const data = {
          target: lng,
          q: q,
          format: 'text'
        };
        const options = {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json'
          }
        };
        let res = await fetch(url, options);

        if (res.ok) {
          let tr = await res.json();
          this.$('.translate-caption').text(tr.data.translations[0].translatedText);
          this.$('.translate-description-short').text(tr.data.translations[1].translatedText);
          this.$('.translate-description').text(tr.data.translations[2].translatedText);
          this.$('.translate-services').text(tr.data.translations[3].translatedText);
          this.$('.translate-specialities').text(tr.data.translations[4].translatedText);
          this.$('.translate-payment_methods_text').text(tr.data.translations[5].translatedText);
        } else {
          originalLang();
        }
      } else {
        originalLang();
      }
    },

    showMenu(ev) {
      const self = this,
            app = this.$app,
            $ = this.$;
      const el = $(ev.target);
      const idx = el.data('idx') * 1; //console.log(idx);

      app.photoBrowser.create({
        photos: self.item.info.menu_images,
        popupCloseLinkText: lng.close,
        swiper: {
          initialSlide: idx
        }
      }).open();
    },

    scrollToMap: function () {
      this.$('.page-content').scrollTop(this.$('#detail-scroll-to-map').offset().top, 300);
    },
    openPromo: function (id) {
      this.promoId = id;
      const app = this.$app;
      const wd = {
        1: 'sunday',
        2: 'monday',
        3: 'tuesday',
        4: 'wednesday',
        5: 'thursday',
        6: 'friday',
        7: 'saturday'
      };

      for (let i = 0; i < this.item.offers.length; i++) {
        if (this.item.offers[i].id == id) {
          this.item.offers[i].wd = '';
          this.item.offers[i].weekdays.split('|').forEach(v => {
            this.item.offers[i].wd += lng[wd[v]] + ' ';
            this.item.offers[i].booking_price_type_text = this.item.offers[i].booking_price_type == 'for_person' ? 'x persona' : '';
          });
          const value = this.item.offers[i].hours ? this.item.offers[i].hours.split('-') : false;

          if (value) {
            const v0 = (value[0] + '').split('.');
            const v1 = (value[1] + '').split('.');
            const v2 = v0[0] + (v0[1] ? ':30' : ':00');
            const v3 = v1[0] + (v1[1] ? ':30' : ':00');
            this.item.offers[i].hoursFormatted = v2 + '-' + v3;
          } else {
            this.item.offers[i].hoursFormatted = '-';
          }

          this.$setState({
            promo: this.item.offers[i]
          }, () => {
            const sw = app.swiper.get('.offer-swiper');
            sw.update();
            app.popup.destroy('.popup-detail-promo');
            const popup = app.popup.create({
              el: '.popup-detail-promo',
              swipeToClose: true
            });
            popup.open();
          });
        }
      }
    },
    bookingPromo: function () {
      if (this.promo.discount * 1) {
        this.$router.navigate('/booking/' + this.item.id + '/' + this.promoId + '/');
      } else {
        this.$router.navigate('/menu_events/' + this.item.id + '/' + this.promoId + '/');
      }
    },

    fullscreen(ev) {
      const elem = ev.target;

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
      }
    },

    getItem() {
      const id = this.$route.params.id;
      const self = this;
      const app = this.$app;
      const wd = {
        1: 'sunday',
        2: 'monday',
        3: 'tuesday',
        4: 'wednesday',
        5: 'thursday',
        6: 'friday',
        7: 'saturday'
      };
      myApp.server.get('imc/item/' + id).then(res => {
        myApp.detailItemType = res.type;
        res.tel = res.phone.replace(/[^\d\+]+/g, '');
        res.info = res.info || {};
        var close = false;

        for (let i in res.info.payment_methods) {
          res.info.payment_methods[i] = lng[res.info.payment_methods[i]];
        }

        if (res.info.weekdays && res.info.weekdays.length > 0) {
          for (let i in res.info.weekdays) {
            if (res.info.weekdays[i]) {
              close = i;
              res.info.closed = lng[self.weekdays[i]];
              break;
            }
          }
        }

        var open = [];

        if (res.info.opening && res.info.opening.length > 0) {
          for (let i in res.info.opening) {
            if (close !== false && i === close) {
              continue;
            }

            let value = '<td>' + lng[self.weekdays[i]] + ': </td><td class="text-align-center">' + (res.info.opening[i].morning || (res.info.opening[i].morning === '' ? 'CHIUSO' : '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')) + '</td><td class="text-align-center">' + (res.info.opening[i].evening && res.info.opening[i].evening != '00:00-00:00' ? res.info.opening[i].evening : res.info.opening[i].evening === '' ? 'CHIUSO' : '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;') + '</td>';
            open.push(value);
          }
        }

        if (open.length > 0) {
          res.info.open = open;
        }

        app.swiper.destroy('.item-swiper');
        app.swiper.destroy('.swiper-reviews');
        app.swiper.destroy('.swiper-offers');
        res.offers.map(e => {
          let gg = '';

          switch (e.weekdays) {
            case '1|2|3|4|5|6|7':
              gg = lng.everyday;
              break;

            case '2|3|4|5|6|7':
              gg = lng.mondayToSaturday;
              break;

            case '2|3|4|5|6':
              gg = lng.mondayToFriday;
              break;

            default:
              e.weekdays.split('|').forEach(i => {
                gg += lng[wd[i]] + ' ';
              });
          }

          e.desc = e.datetime_init + (e.datetime_end ? ' - ' + e.datetime_end : '');
          e.desc = (e.desc || gg) + '<br>' + e.hoursFormatted;
          e.images = e.images || [];
          e.video = e.video || [];

          if (e.image && !e.images.length) {
            e.images.push(e.image);
          }

          return e;
        });
        self.$setState({
          item: res
        }, function () {
          app.swiper.create({
            el: '.item-swiper'
          });
          app.swiper.create({
            el: '.swiper-reviews',
            spaceBetween: 5,
            slidesPerView: 'auto'
          });
          app.swiper.create({
            el: '.swiper-offers',
            spaceBetween: 5,
            slidesPerView: 'auto'
          });
          self.$('video').forEach(el => {
            el.load();

            el.onplay = () => {
              if (el.requestFullscreen) {
                el.requestFullscreen();
              } else if (el.webkitRequestFullscreen) {
                /* Safari */
                el.webkitRequestFullscreen();
              }
            };
          });
        });
        self.setMap(res.latlng);

        if (self.$route.query.offer) {
          self.openPromo(self.$route.query.offer);
        }

        myApp.currentPoi = res;

        if (res.info.menu) {
          self.getMenu();
        }
      }).catch(err => {
        app.toast.show({
          text: lng.genericError,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
      });
    },

    getMenu() {
      const self = this,
            app = this.$app,
            $ = this.$;
      myApp.server.get('imc/menu/' + this.$route.params.id).then(menu => {
        app.swiper.destroy('.swiper-menu');
        self.$setState({
          menu: menu
        }, () => {
          app.swiper.create({
            el: '.swiper-menu',
            spaceBetween: 5,
            slidesPerView: 'auto'
          });
        });
      });
    },

    setMap(latLng) {
      const self = this;
      const icon = L.icon({
        iconUrl: 'static/markers/' + self.item.type + '-4.png',
        iconSize: [56, 56],
        iconAnchor: [28, 56],
        popupAnchor: [0, 0]
      });

      if (myApp.realPosition && false) {
        myApp.detailMap.fitBounds([latLng, myApp.realPosition]);
      } else {
        myApp.detailMap.setView(latLng, 15);
      }

      L.marker(latLng, {
        icon: icon
      }).addTo(myApp.detailMap);
    },

    addToFavorites() {
      const $ = this.$,
            self = this;
      if (!myApp.user.id) return this.$app.panel.open('.panel-left');
      myApp.server.post('imc/favorites/' + this.$route.params.id).then(succ => {
        self.item.favorite = true;
        self.$setState();
      }).catch(err => {
        console.log(err);
      });
    },

    removeToFavorites() {
      const $ = this.$,
            self = this,
            app = this.$app;
      if (!myApp.user.id) return this.$app.panel.open('.panel-left');
      app.dialog.confirm(lng.removeFavoritesMessage.replace('$poi$', self.item.caption), () => {
        myApp.server.delete('imc/favorites/' + this.$route.params.id).then(succ => {
          self.item.favorite = false;
          self.$setState();
        }).catch(err => {
          console.log(err);
        });
      });
    },

    reviews(id) {
      const self = this;

      for (let i in self.item.reviews) {
        const e = self.item.reviews[i];

        if (e.id == id) {
          self.$setState({
            review: e
          }, () => {
            self.$app.popup.create({
              el: '.popup-detail-reviews',
              swipeToClose: true
            }).open();
          });
        }

        break;
      }
    },

    goToMenu() {
      this.$router.navigate('/menu1/' + this.$route.params.id + '/');
    },

    showImage(index) {
      const self = this,
            app = this.$app,
            $ = this.$;
      const photoBrowser = app.photoBrowser.create({
        photos: self.item.images,
        theme: 'dark'
      });
      photoBrowser.open(index);
    },

    share(ev) {
      const self = this,
            app = this.$app,
            $ = this.$;
      let url = 'https://app.infomycity.eu/?x=';
      let qs = '/detail/' + this.item.id + '/';

      if ($(ev.target).data('promo')) {
        qs += '?offer=' + $(ev.target).data('id');
      }

      url += encodeURIComponent(qs);

      if (app.device.cordova) {
        const options = {
          message: 'Visit the following link:',
          subject: 'Share link',
          url: url,
          chooserTitle: 'Share link'
        };

        var onSuccess = function (result) {// reimposta dimensione viewport (se pubblicità attiva)
          // window.location.reload();
        };

        var onError = function (msg) {
          console.log("Sharing failed with message: " + msg);
        };

        window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
      } else {
        app.dialog.alert('Social share non disponibile.', () => window.open(url));
      }
    }

  },
  id: '1cfe50b058',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="right">\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.item.favorite, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <a href="#" @click="removeToFavorites">\n            <i class="icon f7-icons">heart_slash</i>\n          </a>\n          ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <a href="#" @click="addToFavorites">\n            <i class="icon f7-icons">heart</i>\n          </a>\n          ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          <a href="#" @click="share">\n            <img class="share-icon" src="static/share-white.png" alt=""/>\n          </a>\n        </div>\n      </div>\n    </div>\n    <div class="page-content bg-color-white">\n      <div class="swiper-container item-swiper">\n        <div class="swiper-wrapper">\n          ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.item.images, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class="swiper-slide">\n            <div @click="showImage(';
          r += c(data_2 && data_2.index, ctx_2);
          r += ')" class="slide-bg h-33" style="background-image: url(';
          r += c(ctx_2.url, ctx_2);
          r += ')"></div>\n          </div>\n          ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class="swiper-slide">\n            <div class="slide-bg h-33" style="background-image: url(static/demo/';
          r += c(ctx_2.item.type, ctx_2);
          r += '.jpg)"></div>\n          </div>\n          ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n        <div class="slide-bg-title">\n          <spam class="translate-caption">';
      r += c(ctx_1.item.caption, ctx_1);
      r += '</spam> <br> \n          <small class="translate-description-short">';
      r += c(ctx_1.item.description_short, ctx_1);
      r += '</small>\n        </div>\n        ';
      r += Template7Helpers.js_if.call(ctx_1, "this.item.images && this.item.images.length > 1", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        <div class="slide-bg-arrow"><i class="f7-icons">arrow_right_arrow_left</i></div>\n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      </div>\n      <div class="build-images">\n        <div class="row no-gap">\n\n          ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.item.videos, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class="col">\n\n            <video class="video_cover build-image" \n                   controls\n                   style="background-image: url(';
          r += c(ctx_2.url, ctx_2);
          r += '?poster)">\n              <source src="';
          r += c(ctx_2.url, ctx_2);
          r += '" type="video/mp4"> \n            </video>\n\n          </div>\n\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n        </div>\n      </div>\n      <div style="margin: 0 10px;">\n        ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.item.subtypes, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' \n        ';
              r += Template7Helpers.js_if.call(ctx_3, "this != 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' \n        <span class="badge color-deeporange" style="margin-top:3px;">';
                  r += Template7Helpers.js.call(ctx_4, "!isNaN(this) ? myApp.categories[ myApp.detailItemType ][ this ] : lng.deliveryTypes[ this ] ", {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '</span> \n        ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n        <img width="30" class="vertical-align-middle" style="border-radius: 15px; margin-top: 2px; display: inline-block" src="static/lgbt.png" alt=""/>\n        ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' \n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' \n        ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.item.info.filters, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' <span class="badge color-deeppurple text-capitalize" style="margin-top:3px;">';
              r += Template7Helpers.js.call(ctx_3, "lng.filters[@key]", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span> ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' \n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' \n      </div>\n      ';
      r += Template7Helpers.js_if.call(ctx_1, "this.item.info.takeaway || this.item.info.delivery", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <div class="padding-top-half padding-left">\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.item.info.takeaway, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <img width="30" style="border-radius: 8px; vertical-align: middle" src="static/menu/takeaway.png" alt=""/>\n        <span class="text-capitalize" style="margin-top:3px;">Take Away</span>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.item.info.delivery, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <img width="30" style="border-radius: 8px; vertical-align: middle" src="static/menu/delivery.png" alt=""/>\n        <span class="text-capitalize" style="margin-top:3px;">Delivery</span>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      </div>\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n\n\n      <div class="block" style="margin-top:12px; margin-bottom: 0">\n        <!-- Informazioni locale -->\n        <div class="list media-list no-hairlines no-hairlines-between list-sm" style="margin-top: 12px; margin-bottom: 24px">\n          <ul>\n            <li @click="scrollToMap">\n              <div class="item-content">\n                <div class="item-media">\n                  <i class="icon icon-small icon-fill bg-color-primary text-color-white f7-icons">house_fill</i>\n                </div>\n                <div class="item-inner">\n                  ';
      r += c(ctx_1.item.address, ctx_1);
      r += ' - ';
      r += c(ctx_1.item.city, ctx_1);
      r += '\n                </div>\n              </div>\n            </li>\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.item.phone, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <li>\n              <a class="external text-color-black" target="_system" href="tel:';
          r += c(ctx_2.item.tel, ctx_2);
          r += '">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon icon-small icon-fill bg-color-green text-color-white f7-icons">phone_fill</i>\n                  </div>\n                  <div class="item-inner">\n                    ';
          r += c(ctx_2.item.phone, ctx_2);
          r += '\n                  </div>\n                </div>\n              </a>\n            </li>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.item.email, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <li>\n              <a class="external text-color-black" target="_system" href="mailto:';
          r += c(ctx_2.item.email, ctx_2);
          r += '">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon icon-small icon-fill bg-color-blue text-color-white f7-icons">at</i>\n                  </div>\n                  <div class="item-inner">\n                    ';
          r += c(ctx_2.item.email, ctx_2);
          r += '\n                  </div>\n                </div>\n              </a>\n            </li>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.item.web, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <li>\n              <a class="external text-color-black" target="_system" href="';
          r += c(ctx_2.item.web, ctx_2);
          r += '">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon icon-small icon-fill bg-color-red text-color-white f7-icons">globe</i>\n                  </div>\n                  <div class="item-inner">\n                    ';
          r += c(ctx_2.item.web, ctx_2);
          r += '\n                  </div>\n                </div>\n              </a>\n            </li>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.item.fb, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <li>\n              <a class="external text-color-black" target="_system" href="';
          r += c(ctx_2.item.fb, ctx_2);
          r += '">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon icon-small icon-fill bg-color-deeppurple text-color-white f7-icons">logo_facebook</i>\n                  </div>\n                  <div class="item-inner">\n                    ';
          r += c(ctx_2.item.fb, ctx_2);
          r += '\n                  </div>\n                </div>\n              </a>\n            </li>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.item.instagram, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <li>\n              <a class="external text-color-black" target="_system" href="';
          r += c(ctx_2.item.instagram, ctx_2);
          r += '">\n                <div class="item-content">\n                  <div class="item-media">\n                    <i class="icon icon-small icon-fill bg-color-purple text-color-white f7-icons">logo_instagram</i>\n                  </div>\n                  <div class="item-inner">\n                    ';
          r += c(ctx_2.item.instagram, ctx_2);
          r += '\n                  </div>\n                </div>\n              </a>\n            </li>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n          </ul>\n        </div>\n      </div>\n\n      ';
      r += Template7Helpers.js_if.call(ctx_1, "this.item.subscription > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <div class="block">\n        <h3>\n          ';
          r += c(ctx_2.lng.info, ctx_2);
          r += '\n          <a class="float-right actions-open text-color-imc" style="font-weight: normal; font-size: 14px" data-actions=".actions-translate">\n            ';
          r += c(ctx_2.lng.translate, ctx_2);
          r += '\n            <img class="mybutton" style="vertical-align: middle"  width="28" src="static/img/flag_translate.png" alt=""/>\n          </a>\n        </h3>\n        <span class="translate-description"> ';
          r += c(ctx_2.item.description, ctx_2);
          r += ' </span>\n      </div>\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n      ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.item.info.menu, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <div class="block">\n        <a href="#"  @click="goToMenu"\n           class=" button button-large button-round button-fill button-raised bg-color-imc text-color-primary">\n          <i class="icon f7-icons icon-small">doc_richtext</i>\n          ';
          r += Template7Helpers.js_if.call(ctx_2, "this.item.type === 'beach'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += c(ctx_3.lng.priceListServices, ctx_3);
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += c(ctx_3.lng.ourMenu, ctx_3);
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n        </a>\n      </div>\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n      <h3 class="margin-left">';
      r += c(ctx_1.lng.offersPromotions, ctx_1);
      r += '</h3>\n\n      <!-- Promozioni / Offerte / Eventi -->\n      <div class="swiper-container swiper-offers">\n        <div class="swiper-wrapper" style="margin-left: 10px">\n          ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.item.offers, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n\n          ';
          r += Template7Helpers.js_if.call(ctx_2, "this.image && this.type == 'event'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <div class="swiper-slide offer-item-image-slider" @click="openPromo(\'';
              r += c(ctx_3.id, ctx_3);
              r += '\')">\n            <div class="offer-item-image" style="background-image:url(';
              r += c(ctx_3.image, ctx_3);
              r += ')"></div>\n            <div class="offer-item-image-caption">';
              r += c(ctx_3.caption, ctx_3);
              r += '</div>\n            <div  class="offer-item-image-description-short">';
              r += c(ctx_3.desc, ctx_3);
              r += '</div>\n          </div>\n          ';
              r += Template7Helpers.js_if.call(ctx_3, "this.type == 'discount'", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += Template7Helpers.js_if.call(ctx_3, "this.date_init != '0000-00-00' || this.date_end != '0000-00-00'", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += Template7Helpers.js_if.call(ctx_4, "this.date_init != '0000-00-00'", {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += Template7Helpers.js_if.call(ctx_4, "this.date_init != '0000-00-00' && this.date_end != '0000-00-00'", {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += Template7Helpers.js_if.call(ctx_4, "this.date_end != '0000-00-00'", {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <div class="swiper-slide detail-promo offer-item bg-gradient-';
              r += c(data_3 && data_3.index, ctx_3);
              r += '" @click="openPromo(\'';
              r += c(ctx_3.id, ctx_3);
              r += '\')">\n            ';
              r += Template7Helpers.js_if.call(ctx_3, "this.type == 'discount'", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n            <h1 class="offer-item-discount">';
                  r += c(ctx_4.discount, ctx_4);
                  r += '%</h1>\n            ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n            <h1 class="offer-item-caption">';
                  r += c(ctx_4.caption, ctx_4);
                  r += '</h1>\n            ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n            <div  class="offer-item-description-short">';
              r += c(ctx_3.description_short, ctx_3);
              r += '</div>\n\n            ';
              r += Template7Helpers.js_if.call(ctx_3, "this.date_init != '0000-00-00' || this.date_end != '0000-00-00'", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n            <div class="promo-datetime">\n              ';
                  r += Template7Helpers.js_if.call(ctx_4, "this.date_init != '0000-00-00'", {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += Template7Helpers.js.call(ctx_5, "new Date(this.date_init).toLocaleDateString()", {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n              ';
                  r += Template7Helpers.js_if.call(ctx_4, "this.date_init != '0000-00-00' && this.date_end != '0000-00-00'", {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += ' - ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n              ';
                  r += Template7Helpers.js_if.call(ctx_4, "this.date_end != '0000-00-00'", {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += Template7Helpers.js.call(ctx_5, "new Date(this.date_end).toLocaleDateString()", {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n            </div>\n            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n\n            ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.hours, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<div class="promo-datetime-hours">';
                  r += c(ctx_4.hoursFormatted, ctx_4);
                  r += '</div>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n          </div>\n          ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n          ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class=\'padding-left\'>';
          r += c(ctx_2.lng.noOffers, ctx_2);
          r += '</div>\n          ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n      </div>\n\n      <!-- <div class="block" style="margin-bottom: 0; margin-top:24px">\n        <h3 style="margin-bottom: 5px">';
      r += c(ctx_1.lng.customerReviews, ctx_1);
      r += '</h3>\n        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.item.avgStars, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.item.stars, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <i class="icon icon-small f7-icons text-color-primary">';
              r += c(ctx_3, ctx_3);
              r += '</i>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      </div> -->\n\n      <div class="margin-top">&nbsp;</div>\n      <!-- Map -->\n      <div id="detail-scroll-to-map"></div>\n      <div class="text-align-right padding-right">\n        <a class="text-small text-color-imc external" target="_system" \n           href="https://www.google.com/maps/?q=@';
      r += c(ctx_1.item.latlng[0], ctx_1);
      r += ',';
      r += c(ctx_1.item.latlng[1], ctx_1);
      r += '">\n          ';
      r += c(ctx_1.lng.viewOnGoogleMaps, ctx_1);
      r += '®</a>\n      </div>\n      <div style="width: 100%; height: 33vh; background-color:#ccc" id="detail-map"></div>\n\n\n      ';
      r += Template7Helpers.js_if.call(ctx_1, "this.item.subscription > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <div class="block">\n\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.item.info.priceRange, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <h4 class="mb-0">';
              r += c(ctx_3.lng.priceRange, ctx_3);
              r += ': </h4>\n        <span class="badge-rect bg-color-price-';
              r += c(ctx_3.item.info.priceRange, ctx_3);
              r += '">';
              r += Template7Helpers.js.call(ctx_3, "lng[this.priceRange[this.item.info.priceRange]]", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.item.info.open, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <h4 class="mb-0">';
              r += c(ctx_3.lng.open, ctx_3);
              r += '</h4>\n        <table class="table-open">\n          ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.item.info.open, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n          <tr>';
                  r += c(ctx_4, ctx_4);
                  r += '</tr>\n          ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n        </table>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.item.info.closed, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <h4 class="mb-0">';
              r += c(ctx_3.lng.closed, ctx_3);
              r += '</h4>\n        ';
              r += c(ctx_3.item.info.closed || '-', ctx_3);
              r += '\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n        <!-- Menu -->\n        ';
          r += Template7Helpers.js_if.call(ctx_2, "this.item.info.menu || (this.item.info.menu_images && this.item.info.menu_images.length > 0) || this.item.info.menu_pdf || this.item.menu_text", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <h4 class="mb-0">Menu</h4>\n\n        ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.item.info.menu_pdf, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n        <a href="';
                  r += c(ctx_4.item.info.menu_pdf, ctx_4);
                  r += '" \n           target="_system"\n           class="external button button-round button-fill button-raised button-inline bg-color-imc text-color-primary">\n          <i class="icon f7-icons icon-small">doc_richtext</i>\n          PDF\n        </a>\n        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n        ';
              r += Template7Helpers.js_if.call(ctx_3, "this.item.info.menu_images && this.item.info.menu_images.length > 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n        <div class="row margin-top">\n          ';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.item.info.menu_images, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n          <div class="col-25 menu-thumb" \n               @click="showMenu"\n               data-idx="';
                      r += c(data_5 && data_5.index, ctx_5);
                      r += '"\n               style="background-image:url(';
                      r += c(ctx_5, ctx_5);
                      r += ')"></div> \n          ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n        </div>\n        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n        ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.item.info.menu_text, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n        <p>';
                  r += c(ctx_4.item.info.menu_text, ctx_4);
                  r += '</p>\n        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n        <!-- End Menu -->\n\n        <h4 class="mb-0">';
          r += c(ctx_2.lng.services, ctx_2);
          r += '</h4>\n        <span class="translate-services"> ';
          r += c(ctx_2.item.info.services || '-', ctx_2);
          r += ' </span>\n\n        <!--\n        <h4 class="mb-0">';
          r += c(ctx_2.lng.placeAvailable, ctx_2);
          r += '</h4>\n        ';
          r += c(ctx_2.item.info.placeAvailable || '-', ctx_2);
          r += '\n        -->\n\n        <h4 class="mb-0">';
          r += c(ctx_2.lng.specialties, ctx_2);
          r += '</h4>\n        <span class="translate-specialities"> ';
          r += c(ctx_2.item.info.specialities || '-', ctx_2);
          r += ' </span>\n\n        <h4 class="mb-0">';
          r += c(ctx_2.lng.paymentMethod, ctx_2);
          r += '</h4>\n        ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.item.info.payment_methods, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <span class="badge-rect bg-color-imc">';
              r += c(ctx_3, ctx_3);
              r += '</span>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' \n        <br>\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.item.info.payment_methods_text, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        <span class="badge-rect bg-color-imc translate-payment_methods_text">';
              r += c(ctx_3.item.info.payment_methods_text, ctx_3);
              r += '</span>\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n\n        <!-- Recensioni clienti -->\n        <div class="block" id="reviews" style="margin-bottom:10px; margin-top:24px">\n          <h3 style="margin-bottom: 5px">';
          r += c(ctx_2.lng.customerReviews, ctx_2);
          r += '</h3>\n        </div>\n        <div class="swiper-container swiper-reviews">\n          <div class="swiper-wrapper" style="margin-left: 10px">\n            ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.item.reviews, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n            <div class="swiper-slide detail-reviews" @click="reviews(\'';
              r += c(ctx_3.id, ctx_3);
              r += '\')">\n              <div class="reviews-avatar" style="background-image: url(';
              r += Template7Helpers.js.call(ctx_3, "this.avatar||'static/avatar-1.svg'", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ')"></div>\n              <div class="reviews-name">\n                ';
              r += c(ctx_3.name, ctx_3);
              r += '\n              </div>\n              <div class="reviews-stars">\n                <i class="icon icon-small f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars > 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-small f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars > 1", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-small f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars > 2", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-small f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars > 3", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-small f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars > 4", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n              </div>\n              <div class="reviews-text">\n                <strong>';
              r += c(ctx_3.title, ctx_3);
              r += '</strong>\n                <div>';
              r += Template7Helpers.js.call(ctx_3, "this.comment.substring(0,55)", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += Template7Helpers.js_if.call(ctx_3, "this.comment.length > 55", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' ... ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</div>\n              </div>\n              <a class="reviews-readmore" href="#">';
              r += c(root.lng.readMore, ctx_3);
              r += '...</a>\n            </div>\n            ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n            <div class=\'padding-left\'>';
              r += c(ctx_3.lng.noReviews, ctx_3);
              r += '</div>\n            ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n          </div>\n        </div>\n\n        <div class="row no-gap">\n          ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.item.images, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <div class="col-50">\n            <img src="';
              r += c(ctx_3.url, ctx_3);
              r += '" \n                 style="width: calc(50vw - 20px); height: calc(50vw - 20px); object-fit: cover; object-position: center center" \n                 @click="showImage(';
              r += c(data_3 && data_3.index, ctx_3);
              r += ')" />\n          </div>\n          ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n        </div>\n\n      </div>\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n\n\n      <!-- Separatore -->\n      <div style="height: 50px;"></div>\n\n      <!-- Butons Fixed -->\n      ';
      r += Template7Helpers.js_if.call(ctx_1, "this.item.subscription > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <div id="detail-buttons-bottom-group">\n\n        ';
          r += Template7Helpers.js_if.call(ctx_2, "this.item.type === 'restaurant' || this.item.type === 'bar'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.item.info.menu, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' \n        ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.item.info.only_takeaway_delivery, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n        ';
                      r += Template7Helpers.unless.call(ctx_5, ctx_5.item.info.order_locked, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n        <a href="/menu/';
                          r += c(ctx_6.item.id, ctx_6);
                          r += '/"\n           class="link popup-close button button-large button-fill button-round bg-color-green text-color-white button-order-fixed-large">\n          ';
                          r += c(ctx_6.lng.order, ctx_6);
                          r += '\n          <img width="22" src="static/check.png" alt=""/>\n        </a>\n        ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n        ';
                      return r;
                    },
                    inverse: function (ctx_5, data_5) {
                      var r = '';
                      r += ' <!-- item.info.only_takeaway_delivery -->\n        ';
                      r += Template7Helpers.unless.call(ctx_5, ctx_5.item.info.order_locked, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n        <a href="/menu/';
                          r += c(ctx_6.item.id, ctx_6);
                          r += '/"\n           class="link popup-close button button-large button-fill button-round bg-color-green text-color-white button-order-fixed">\n          ';
                          r += c(ctx_6.lng.order, ctx_6);
                          r += '\n          <img width="22" src="static/check.png" alt=""/>\n        </a>\n        ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n        <a href="/booking/';
                      r += c(ctx_5.item.id, ctx_5);
                      r += '/"\n           class="link popup-close button button-large button-fill button-round bg-color-imc text-color-white button-booking-fixed-small">\n          ';
                      r += c(ctx_5.lng.book, ctx_5);
                      r += '\n          <img width="22" src="static/check.png" alt=""/>\n        </a>\n        ';
                      return r;
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += ' <!-- item.info.only_takeaway_delivery -->\n\n        ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <!-- item.info.menu -->\n\n        <a href="/booking/';
                  r += c(ctx_4.item.id, ctx_4);
                  r += '/"\n           class="link popup-close button button-large button-fill button-round bg-color-imc text-color-white button-booking-fixed">\n          ';
                  r += c(ctx_4.lng.book, ctx_4);
                  r += '\n          <img width="22" src="static/check.png" alt=""/>\n        </a>\n        ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' <!-- item.info.menu -->\n        \n        ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += ' \n        <a href="/menu/';
              r += c(ctx_3.item.id, ctx_3);
              r += '/?booking=1"\n           class="link popup-close button button-large button-fill button-round bg-color-imc text-color-white button-booking-fixed">\n          ';
              r += c(ctx_3.lng.book, ctx_3);
              r += '\n          <img width="22" src="static/check.png" alt=""/>\n        </a>\n        ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n        <a href="/chat/';
          r += c(ctx_2.item.id, ctx_2);
          r += '/" \n           class="button button-large button-fill button-round bg-color-primary text-color-imc button-chat-fixed">\n          <i class="icon f7-icons button-fixed-chat ios-only">chat_bubble_text_fill</i>\n          <i class="icon material-icons button-fixed-chat md-only">chat</i>\n        </a>\n\n      </div>\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n      <!-- Popup Evento / Offerta -->\n      <div class="popup popup-detail-promo popup-tablet-fullscreen">\n        <div class="view">\n          <div class="page">\n            <div class="navbar bg-color-imc">\n              <div class="navbar-bg bg-color-imc"></div>\n              <div class="navbar-inner bg-color-imc">\n                <div class="title center sliding">';
      r += c(ctx_1.item.caption, ctx_1);
      r += '</div>\n                <div class="right">\n                  <a class="link popup-close">\n                    <i class="icon f7-icons text-color-primary">multiply_circle_fill</i>\n                  </a>\n                </div>\n              </div>\n            </div>\n\n            <div class="toolbar  toolbar-bottom" style="background: none; padding: 0">\n              <div class="toolbar-inner" style="padding:0; margin:0">\n                <a class="popup-close button button-large button-fill button-round bg-color-imc text-color-white margin-top"\n                   style="margin:0 auto 15px auto; width: 80%"\n                   href="#" @click="bookingPromo()">\n                  ';
      r += c(ctx_1.lng.book, ctx_1);
      r += '\n                  <img width="22" src="static/check.png" alt=""/>\n                </a>\n              </div>\n            </div>\n\n            <div class="page-content">\n\n              <div class="swiper-container offer-swiper swiper-init">\n                <div class="swiper-wrapper">\n\n                  ';
      r += Template7Helpers.js_if.call(ctx_1, "this.promo.images.length && this.promo.type == 'event'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' \n                  ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.promo.images, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                  <div class="swiper-slide">\n                    <div class="contain" @click="showImages(';
              r += c(data_3 && data_3.index, ctx_3);
              r += ',\'promo\')" style="background-image: url(';
              r += c(ctx_3, ctx_3);
              r += '); height: 33vh"></div>\n                  </div>\n                  ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                  ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  <!-- immagini locale -->\n                  ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.item.images, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                  <div class="swiper-slide">\n                    <div class="contain" @click="showImages(';
              r += c(data_3 && data_3.index, ctx_3);
              r += ',\'item\')" style="background-image: url(';
              r += c(ctx_3.url, ctx_3);
              r += '); height: 33vh"></div>\n                  </div>\n                  ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                  <div class="swiper-slide">\n                    <div class="contain" style="background-image: url(static/demo/';
              r += c(ctx_3.item.type, ctx_3);
              r += '.jpg); height: 33vh"></div>\n                  </div>\n                  ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                  ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </div>\n              </div>\n\n              ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.promo.video.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <div class="promo-video-container">\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.promo.video, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <video class="video_cover promo-video--image" \n                       controls\n                       style="background-image: url(';
              r += c(ctx_3.url, ctx_3);
              r += '?poster)">\n                  <source src="';
              r += c(ctx_3.url, ctx_3);
              r += '" type="video/mp4"> \n                </video>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              </div>\n              ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n              <!-- Dettagli -->\n              <div class="block">\n                ';
      r += Template7Helpers.js_if.call(ctx_1, "this.promo.discount > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <h1>-';
          r += c(ctx_2.promo.discount, ctx_2);
          r += '%</h1>\n                ';
          r += Template7Helpers.js_if.call(ctx_2, "this.promo.discount_drinks_not_included == '1'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                ';
              r += c(ctx_3.lng.drinks_not_included, ctx_3);
              r += '\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <h3>';
          r += c(ctx_2.promo.caption, ctx_2);
          r += '</h3>\n                ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.promo.description_short, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <h4>';
          r += c(ctx_2.promo.description_short, ctx_2);
          r += '</h4>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                <p>';
      r += c(ctx_1.lng.promo_code, ctx_1);
      r += ': <strong>';
      r += c(ctx_1.promo.promo_code, ctx_1);
      r += '</strong></p>\n                <p>';
      r += c(ctx_1.promo.description, ctx_1);
      r += '</p>\n                <h3 class="detail-promo-from-to">Offerta valida\n                  ';
      r += Template7Helpers.js_if.call(ctx_1, "this.promo.date_init != '0000-00-00'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  dal ';
          r += c(ctx_2.promo.date_init, ctx_2);
          r += '\n                  ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                  ';
      r += Template7Helpers.js_if.call(ctx_1, "this.promo.date_end != '0000-00-00'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  fino al ';
          r += c(ctx_2.promo.date_end, ctx_2);
          r += '\n                  ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </h3>\n\n                <p><strong>';
      r += c(ctx_1.lng.days, ctx_1);
      r += '</strong> <br> ';
      r += c(ctx_1.promo.wd, ctx_1);
      r += ' </p>\n                <p><strong>';
      r += c(ctx_1.lng.hour, ctx_1);
      r += '</strong> <br> ';
      r += c(ctx_1.promo.hoursFormatted, ctx_1);
      r += '</p>\n                <p>\n                  ';
      r += c(ctx_1.lng.promo_minimum_diners, ctx_1);
      r += ' ';
      r += c(ctx_1.promo.diners_min, ctx_1);
      r += ' \n                  ';
      r += c(ctx_1.lng.promo_maximum_diners, ctx_1);
      r += ' ';
      r += c(ctx_1.promo.diners_max, ctx_1);
      r += ' \n                  <span style="text-transform: lowercase">';
      r += c(ctx_1.lng.diners, ctx_1);
      r += '</span>.\n                </p>\n                <!-- <p>\n                  <strong>';
      r += c(ctx_1.lng.bookingFee, ctx_1);
      r += ': </strong> \n                  ';
      r += Template7Helpers.js_if.call(ctx_1, "this.promo.booking_price > 0.00", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  ';
          r += c(ctx_2.promo.booking_price_cur, ctx_2);
          r += ' ';
          r += c(ctx_2.promo.booking_price, ctx_2);
          r += ' ';
          r += c(ctx_2.promo.booking_price_type_text, ctx_2);
          r += '\n                  ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                  ';
          r += c(ctx_2.lng.free, ctx_2);
          r += '\n                  ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </p> -->\n\n                <p>\n                  <a href="#" class="text-color-black" @click="share" data-promo="true" data-id="';
      r += c(ctx_1.promo.id, ctx_1);
      r += '">\n                    <img class="share-icon" src="static/share-black.png" alt=""/>\n                    ';
      r += c(ctx_1.lng.shareLink, ctx_1);
      r += '\n                  </a>\n                </p>\n\n                <div style=\'height: 20vh\'></div>\n\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!-- Popup Reviews -->\n      <div class="popup popup-detail-reviews">\n        <div class="view">\n          <div class="page">\n            <div class="navbar bg-color-imc">\n              <div class="navbar-bg bg-color-imc"></div>\n              <div class="navbar-inner bg-color-imc">\n                <div class="title center sliding">';
      r += c(ctx_1.item.caption, ctx_1);
      r += '</div>\n                <div class="right">\n                  <a class="link popup-close">\n                    <i class="icon f7-icons text-color-primary">multiply_circle_fill</i>\n                  </a>\n                </div>\n              </div>\n            </div>\n\n            <div class="page-content">\n              <!-- immagini locale -->\n              ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.item.images[0], {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <div class="detail-offer-image" style="background-image: url(';
          r += c(ctx_2.item.images[0].url, ctx_2);
          r += ')"></div>\n              ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <div class="detail-offer-image" style="background-image: url(static/demo/';
          r += c(ctx_2.item.type, ctx_2);
          r += '.jpg)"></div>\n              ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n              <!-- Dettagli -->\n              <div class="block">\n                <div class="review-avatar" style="background-image: url(';
      r += Template7Helpers.js.call(ctx_1, "this.review.avatar||'static/avatar-1.svg'", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ')"></div>\n                <div class="review-name">\n                  ';
      r += c(ctx_1.review.name, ctx_1);
      r += '\n                </div>\n                <div class="review-stars">\n                  <i class="icon f7-icons text-color-primary">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.review.stars > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i>\n                  <i class="icon f7-icons text-color-primary">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.review.stars > 1", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i>\n                  <i class="icon f7-icons text-color-primary">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.review.stars > 2", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i>\n                  <i class="icon f7-icons text-color-primary">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.review.stars > 3", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i>\n                  <i class="icon f7-icons text-color-primary">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.review.stars > 4", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i>\n                </div>\n\n                ';
      r += Template7Helpers.js_if.call(ctx_1, "this.review.stars_location > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div>\n                  Location\n                  <i class="icon icon-xs f7-icons text-color-primary">star_fill</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_location > 1", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_location > 2", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_location > 3", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_location > 4", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                </div>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                ';
      r += Template7Helpers.js_if.call(ctx_1, "this.review.stars_service > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div>\n                  Service\n                  <i class="icon icon-xs f7-icons text-color-primary">star_fill</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_service > 1", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_service > 2", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_service > 3", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_service > 4", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                </div>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                ';
      r += Template7Helpers.js_if.call(ctx_1, "this.review.stars_menu > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div>\n                  Menu / Performance\n                  <i class="icon icon-xs f7-icons text-color-primary">star_fill</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_menu > 1", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_menu > 2", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_menu > 3", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_menu > 4", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                </div>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                ';
      r += Template7Helpers.js_if.call(ctx_1, "this.review.stars_price > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div>\n                  ';
          r += c(ctx_2.lng.price, ctx_2);
          r += '\n                  <i class="icon icon-xs f7-icons text-color-primary">star_fill</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_price > 1", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_price > 2", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_price > 3", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                  <i class="icon icon-xs f7-icons text-color-primary">star';
          r += Template7Helpers.js_if.call(ctx_2, "this.review.stars_price > 4", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '_fill';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</i>\n                </div>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                <div class="review-text">\n                  <strong>';
      r += c(ctx_1.review.title, ctx_1);
      r += '</strong>\n                  <div>';
      r += c(ctx_1.review.comment, ctx_1);
      r += '</div>\n                </div>\n              </div>\n\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="actions-modal actions-translate">\n      <div class="list">\n        <ul>\n          <li>\n            <a href="#" @click="translate(\'en\')" class="item-link item-content actions-close">\n              <div class="item-media">\n                <img width="28" src="static/img/flag_en.png" alt=""/>\n              </div>\n              <div class="item-inner">English</div>\n            </a>\n          </li>\n          <li>\n            <a href="#" @click="translate(\'fr\')"  class="item-link item-content actions-close">\n              <div class="item-media">\n                <img width="28" src="static/img/flag_fr.png" alt=""/>\n              </div>\n              <div class="item-inner">Français</div>\n            </a>\n          </li>\n          <li>\n            <a href="#" @click="translate(\'it\')"  class="item-link item-content actions-close">\n              <div class="item-media">\n                <img width="28" src="static/img/flag_it.png" alt=""/>\n              </div>\n              <div class="item-inner">Italiano</div>\n            </a>\n          </li>\n          <li>\n            <a href="#" @click="translate(\'es\')"  class="item-link item-content actions-close">\n              <div class="item-media">\n                <img width="28" src="static/img/flag_es.png" alt=""/>\n              </div>\n              <div class="item-inner">Español</div>\n            </a>\n          </li>\n          <li>\n            <a href="#" @click="translate(\'de\')"  class="item-link item-content actions-close">\n              <div class="item-media">\n                <img width="28" src="static/img/flag_de.png" alt=""/>\n              </div>\n              <div class="item-inner">Deutsche</div>\n            </a>\n          </li>\n          <li>\n            <a href="#" @click="translate(\'-\')"  class="item-link item-content actions-close">\n              <div class="item-media">\n                <img width="28" src="static/img/flag_translate.png" alt=""/>\n              </div>\n              <div class="item-inner text-color-imc">';
      r += c(ctx_1.lng.originalLanguage, ctx_1);
      r += '</div>\n            </a>\n          </li>\n        </ul>\n      </div>\n    </div>\n\n  </div>\n</div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    